import React from 'react'
import image from '../images/me.png'
import styles from '../stylesheets/Image.module.scss'

function Image() {
    return (
        <div>
            <img
                src={image}
                alt="Me"
                className={styles.me}
            />
        </div>
    )
}

export default Image
